// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor1 from '@/game/prefabs/World/Mentors/Mentor1';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level1 extends TilemapScene {
  constructor() {
    super('Level1');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // forest_biome_1
    const forest_biome_1 = this.add.tilemap('forest-biome-1');
    forest_biome_1.addTilesetImage('summer forest', 'summer forest');
    forest_biome_1.addTilesetImage(
      'summer trees 80x112',
      'summer trees 80x112',
    );
    forest_biome_1.addTilesetImage('summer 32x32', 'summer 32x32');
    forest_biome_1.addTilesetImage('collision', 'collision & alpha');

    // ground_1___summer_forest_1
    forest_biome_1.createLayer(
      'Ground 1 - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // some_tree_bits___summer_forest_1
    forest_biome_1.createLayer(
      'Some tree bits - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // details___summer_forest_1
    forest_biome_1.createLayer(
      'Details - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // tOP_covering_foliage___summer_forest_1
    const tOP_covering_foliage___summer_forest_1 = forest_biome_1.createLayer(
      'TOP covering foliage - summer forest',
      ['summer forest'],
      0,
      0,
    )!;
    tOP_covering_foliage___summer_forest_1.visible = false;

    // cOLLISION_1
    const cOLLISION_1 = forest_biome_1.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 75, 152);
    this.add.existing(player);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 93, 212);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 350, 105);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 481, 134);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 505, 236);
    this.add.existing(worldNode_4);

    // worldNode
    const worldNode = new WorldNode(this, 85, 78);
    this.add.existing(worldNode);

    // portal
    const portal = new Portal(this, 550, 260);
    this.add.existing(portal);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 347, 234);
    this.add.existing(worldNode_5);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 219, 284);
    this.add.existing(forestTree1);

    // forestTree_29
    const forestTree_29 = new ForestTree1(
      this,
      169,
      35,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_29);

    // forestTree
    const forestTree = new ForestTree1(this, 8, 308);
    this.add.existing(forestTree);

    // forestTree_3
    const forestTree_3 = new ForestTree1(this, 129, 315);
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(this, -3, 119);
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(this, 51, 54);
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(this, 122, 38);
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(this, 209, 60);
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(this, 134, 94);
    this.add.existing(forestTree_8);

    // forestTree_10
    const forestTree_10 = new ForestTree1(this, 625, 57);
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(this, 543, 50);
    this.add.existing(forestTree_11);

    // forestTree_13
    const forestTree_13 = new ForestTree1(this, 633, 149);
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(this, 661, 197);
    this.add.existing(forestTree_14);

    // forestTree_16
    const forestTree_16 = new ForestTree1(this, 474, 333);
    this.add.existing(forestTree_16);

    // forestTree_18
    const forestTree_18 = new ForestTree1(this, 357, 326);
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(this, 292, 292);
    this.add.existing(forestTree_19);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      423,
      256,
      'summer_trees_sheet',
      1,
    );
    this.add.existing(forestTree_21);

    // forestTree_1
    const forestTree_1 = new ForestTree1(this, 248, 113);
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      280,
      65,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_2);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      489,
      68,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_9);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      411,
      317,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_12);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      246,
      369,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_15);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      70,
      329,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_17);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      612,
      239,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_20);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      640,
      323,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      315,
      114,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      163,
      298,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      256,
      262,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(
      this,
      29,
      95,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(this, 439, 81);
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(
      this,
      175,
      104,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_28);

    // mentor
    const mentor = new Mentor1(this, 41, 132);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 593, 90);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 229, 187);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 286, 119);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 430, 163);
    this.add.existing(worldNode_9);

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 0;
    worldNode_1.NPCId = 5;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 0;
    worldNode_2.NPCId = 4;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 0;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 0;
    worldNode_4.NPCId = 2;

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 0;
    worldNode.NPCId = 0;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 0;
    worldNode_5.NPCId = 1;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 0;
    worldNode_6.NPCId = 1;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 0;
    worldNode_7.NPCId = 1;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 0;
    worldNode_8.NPCId = 1;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 0;
    worldNode_9.NPCId = 1;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.forest_biome_1 = forest_biome_1;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor1;
  private forest_biome_1!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.forest_biome_1,
      portal: this.portal,
      mentor: this.mentor,
    });

    //this.forest_biome_1.createFromObjects("Top Trees", {id: 9});
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
